module.exports = __webpack_public_path__ + "static/media/home-illustration.2604e19c.png";